import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { CLOSE_STAGE_LABEL } from "../Tabs/CloseStageFilter/closeStage.constants";

interface Props {
    filters: FiltersTypes;
}

export const CloseStageFilterLabel: React.FC<Props> = ({ filters }) => {
    const { closeStage } = filters;

    if (!closeStage || closeStage.length === 0) {
        return null;
    }

    if (closeStage.length === 1) {
        return <span>{CLOSE_STAGE_LABEL[closeStage[0]]}</span>;
    }

    return <span>{closeStage.length} stages</span>;
};
